module.exports = __webpack_public_path__ + "img/194.05f31ece.jpg";